import { OnboardingStep } from '../../OnboardingStep/OnboardingStep'
import { getStepStatus } from '../utils'

interface FirstOrderStepProps {
  readonly completed: boolean
  readonly enabled: boolean
}

export function FirstOrderStep({
  completed,
  enabled
}: Readonly<FirstOrderStepProps>) {
  return (
    <OnboardingStep
      title="Place Your First Order"
      description="Set your taste profile and discover chefs who perfectly match your preferences."
      status={getStepStatus(completed, enabled)}
      icon="check"
    />
  )
}
